import React, { useContext } from "react";
import { TextField, Box } from "@mui/material";
import { PuceContext } from "context/AppContext";

const PuceDetails = () => {
  const puceContext = useContext(PuceContext);

  const { selectedData } = puceContext;

  return (
    <Box
      sx={{
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        margin: 2,
        position: "relative",
      }}
      style={{ backgroundColor: "white" }}
    >
      {/* <Box textAlign="center">
        <Typography variant="h6">Fiche de la puce</Typography>
      </Box> */}
      <TextField
        label="Numéro"
        name="numero"
        value={selectedData?.numero ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        label="Reference de l'animal"
        name="animalReference"
        value={selectedData?.animalReference ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="lotPuce"
        label="Lot"
        value={selectedData?.lotPuce?.reference ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="fabricant"
        label="Fabricant"
        value={selectedData?.lotPuce?.fabricant ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="pays"
        label="Pays"
        value={selectedData?.lotPuce?.pays ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="categorie"
        label="Catégorie"
        value={selectedData?.lotPuce?.categorie ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="type"
        label="Type"
        value={selectedData?.lotPuce?.typePuce ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="agent"
        label="Admin Departemental"
        value={`${selectedData?.lotPuce?.adminDepartemental?.prenom ?? ""}-${
          selectedData?.lotPuce?.adminDepartemental?.nom ?? ""
        }, ${selectedData?.lotPuce?.adminDepartemental?.numTel ?? ""}`}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="agent"
        label="Agent Identificateur"
        value={`${selectedData?.lotPuce?.agent?.prenom ?? ""}-${
          selectedData?.lotPuce?.agent?.nom ?? ""
        }, ${selectedData?.lotPuce?.agent?.numTel ?? ""}`}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="status"
        label="Statut"
        value={selectedData?.status ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
    </Box>
  );
};

export default PuceDetails;
